const LabelH4 = ({ title, secondaryTitle, extraClassName, secondaryClassName, description }) => {
    return (
        <div>
            <h4 className={`text-xl color-verdigris mb-3 ${extraClassName || ""}`}>
                {title}
            </h4>
            {secondaryTitle && <h5 className={`mb-2 font-bold text-lg karla ${secondaryClassName || ""}`}>
                {secondaryTitle}
            </h5>}
            {description && <p>
                Which party are you releasing your music with? Please choose either
                Label or Distributor.
            </p>}
        </div>
    )
}

export default LabelH4